import React from 'react';

const Options = (props) => {
  const { activeCategory, setCategory, content } = props;
  return (
    <div className='options'>
      <button
        onClick={() => setCategory('c1')}
        className={activeCategory === 'c1' ? 'active' : ''}
      >{content.schools.button}
      </button>
      <button
        onClick={() => setCategory('c2')}
        className={activeCategory === 'c2' ? 'active' : ''}
      >{content.workplace.button}
      </button>
      <button
        onClick={() => setCategory('c6')}
        className={activeCategory === 'c6' ? 'active' : ''}
      >{content.home.button}
      </button>
      <button
        onClick={() => setCategory('c8')}
        className={activeCategory === 'c8' ? 'active' : ''}
      >{content.borders.button}
      </button>
    </div>
  );
};

export default Options;
